module.exports = __webpack_public_path__ + "static/media/smoothing-dark.7e050aca.svg";